import * as types from './OrdersActionTypes';
import OrdersApi from './OrdersApi';
import { ICreateOrder } from './Entities';
import ICoordinate from '../map/ICoordinate';

function newOrderSuccess(newOrder: any) {
    return { type: types.NEW_ORDER_SUCCESS, result: newOrder };
}

export function newOrder(
    pendingOrderId?: string,
    orderCollectionId?: number,
    newPendingOrder?: boolean
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.newOrder(pendingOrderId, orderCollectionId, newPendingOrder).then(
            (result: any) => {
                dispatch(newOrderSuccess(result));
            }
        );
}

export function cloneOrder(orderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.cloneOrder(orderId).then(
            (result: any) => {
                dispatch(newOrderSuccess(result));
            }
        );
}

function newOrderProductsSuccess(newOrder: any) {
    return { type: types.NEW_ORDER_PRODUCTS_SUCCESS, result: newOrder };
}

export function newOrderProducts(firmId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.newOrderProducts(firmId).then((result: any) => {
            dispatch(newOrderProductsSuccess(result));
        });
}

function createOrderSuccess(order: any) {
    return { type: types.CREATE_ORDER_SUCCESS, result: order };
}

export function createOrder(
    order: ICreateOrder,
    orderCollectionId?: number,
    onlyValidate: boolean = false
) {
    return (dispatch: (result: any) => void) =>
        OrdersApi.createOrder(order, onlyValidate, orderCollectionId).then((result: any) => {
            if (!onlyValidate) {
                dispatch(createOrderSuccess(result));
            }
            return result;
        });
}

function getOrdersSuccess(orders: any) {
    return { type: types.GET_ORDERS_SUCCESS, result: orders };
}

export function getOrders() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getOrders().then((result: any) => {
            dispatch(getOrdersSuccess(result));
        });
}

function getPlanOrdersSuccess(orders: any) {
    return { type: types.GET_PLAN_ORDERS_SUCCESS, result: orders };
}

export function getPlanOrders() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getPlanOrders().then((result: any) => {
            dispatch(getPlanOrdersSuccess(result));
        });
}

function getAgreementSuccess(orders: any) {
    return { type: types.GET_AGREEMENT_SUCCESS, result: orders };
}

export function getAgreement(agreementKey: number): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getAgreement(agreementKey).then((result: any) => {
            dispatch(getAgreementSuccess(result));
        });
}

function getPhotoOrdersSuccess(orders: any) {
    return { type: types.GET_PHOTO_ORDERS_SUCCESS, result: orders };
}

export function getPhotoOrders(year: number, month: number, day: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getPhotoOrders(year, month, day).then((result: any) => {
            dispatch(getPhotoOrdersSuccess(result));
        });
}

function getUnBookedOrdersSuccess(orders: any) {
    return { type: types.GET_UNBOOKED_ORDERS_SUCCESS, result: orders };
}

export function getUnBookedOrders() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getUnBookedOrders().then((result: any) => {
            dispatch(getUnBookedOrdersSuccess(result));
        });
}

function getFilmOrdersSuccess(orders: any) {
    return { type: types.GET_FILM_ORDERS_SUCCESS, result: orders };
}

export function getFilmOrders(year: number, month: number, day: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getFilmOrders(year, month, day).then((result: any) => {
            dispatch(getFilmOrdersSuccess(result));
        });
}

function getAdvanceSearchFiltersSuccess(filters: any) {
    return { type: types.GET_ADVANCE_SEARCH_FILTERS_SUCCESS, result: filters };
}

export function getAdvanceSearchFilters() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getAdvanceSearchFilters().then((result: any) => {
            dispatch(getAdvanceSearchFiltersSuccess(result));
        });
}

function getAdvanceSearchOrdersSuccess(orders: any) {
    return { type: types.GET_ADVANCE_SEARCH_ORDERS_SUCCESS, result: orders };
}

export function getAdvanceSearchOrders(params: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        OrdersApi.getAdvanceSearchOrders(params).then((result: any) => {
            dispatch(getAdvanceSearchOrdersSuccess(result));
        });
}

export function getFirmsForAdvanceSearch(name: string, brokerChainId: number) {
    return OrdersApi.getFirmsForAdvanceSearch(name, brokerChainId);
}

export function getAgentsForAdvanceSearch(brokerChainId: number, brokerFirmId: number) {
    return OrdersApi.getAgentsForAdvanceSearch(brokerChainId, brokerFirmId);
}

export function saveFilter(filter: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        dispatch({
            type: types.SAVE_ADVANCE_SEARCH_FILTER_SUCCESS,
            result: filter
        });
}

export function saveAgentBrokerFilters(filter: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        dispatch({
            type: types.SAVE_AGENT_BROKER_FILTERS_SUCCESS,
            result: filter
        });
}

function checkIfOrderIsArchivedSuccess(result: any) {
    return { type: types.CHECK_IF_ORDER_IS_ARCHIVED_SUCCESS, result: result };
}

export function checkIfOrderIsArchived(orderId: number) {
    return (dispatch: (result: any) => void) =>
        OrdersApi.checkIfOrderIsArchived(orderId).then((result: any) => {
            dispatch(checkIfOrderIsArchivedSuccess(result));
            return result;
        });
}

function saveOrderCommandForBookingSuccess(orderCommand: any) {
    return {
        type: types.SAVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS,
        result: orderCommand
    };
}

export function saveOrderCommandForBooking(orderCommand: any) {
    return (dispatch: (result: any) => void) =>
        dispatch(saveOrderCommandForBookingSuccess(orderCommand));
}

function removeOrderCommandForBookingSuccess() {
    return { type: types.REMOVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS };
}

export function removeOrderCommandForBooking() {
    return (dispatch: (result: any) => void) => dispatch(removeOrderCommandForBookingSuccess());
}
